"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
exports.tap = operators_1.tap;
//# sourceMappingURL=tap.js.map